import type { VoidFunctionComponent } from 'react';

import useMultipleModals from '../../../hooks/useMultipleModals';
import { icons } from '../../generic';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../generic/Button';
import { IgnoreIssuesModalCategoryContainer } from '../modals/IgnoreIssuesModal';

/**
 * AddIgnoreRuleButton includes the button and the modal
 * for the ignore action on the issue exceptions page. The modal state is managed
 * by useMultipleModals, which passes the modal state down as context. Go see the
 * IssueDetailsModalsContext for more info.
 */

type AddIgnoreRuleButtonProps = {
  projectId?: string;
};

const AddIgnoreRuleButton: VoidFunctionComponent<AddIgnoreRuleButtonProps> = ({ projectId }) => {
  const { ignoreModal } = useMultipleModals('ignore');
  return (
    <>
      <Button
        type={BUTTON_TYPE.PRIMARY}
        size={BUTTON_SIZE.MEDIUM}
        onClick={ignoreModal.onOpen}
        isDisabled={ignoreModal.isOpen}
        icon={icons.add}
      >
        Add Ignore Rule
      </Button>
      <IgnoreIssuesModalCategoryContainer
        show={ignoreModal.isOpen}
        onHide={ignoreModal.onClose}
        projectId={projectId}
      />
    </>
  );
};

export default AddIgnoreRuleButton;
